// REACT & Libraries
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

// Table
import AttachmentCatgoryTable from "../../DataTables/MasterData/AttachmentCatgory/AttachmentCatgoryTable";

// Modals
import CreateAttachmentCatgoryModal from "../../UiKits/Modal/MasterData/AttachmentCatgory/CreateAttachmentCatgory";

const AttachmentCategoryContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Attachment Categories" parent="Master Data" />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">Attachment Categories Master Data</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage attachment categories options used throughout the HRIS
                  for employee and applicant personal information.
                </P>
                <CreateAttachmentCatgoryModal />
                <AttachmentCatgoryTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AttachmentCategoryContainer;
